import React from "react"
import { Redirect, Route, Switch } from "react-router-dom"
import { Employee } from "types/Employee"
import { CreatePlan } from "./create-plan"
import Plan from "./plan"
import CarrotPlanList from "../../../components/carrotplans/CarrotPlanList"
import RoutingInfoWrapper from "./routing-info"

const BASE_ROUTING_PATH = "/employees/:employeeId/carrot-plans"

type AllPlansProps = {
  employee: Employee
}

export default function AllPlans({ employee }: AllPlansProps): JSX.Element {
  return (
    <Switch>
      <Route
        exact
        path={BASE_ROUTING_PATH}
        render={(): JSX.Element => <CarrotPlanList employeeId={employee.employeeId} />}
      />
      <Route
        exact
        path={`${BASE_ROUTING_PATH}/routing-info`}
        render={(): JSX.Element => <RoutingInfoWrapper employee={employee} />}
      />
      <Redirect exact from={`${BASE_ROUTING_PATH}/create-plan`} to={`${BASE_ROUTING_PATH}/create-plan-v2`} />
      <Redirect exact from={`${BASE_ROUTING_PATH}/create-plan/review`} to={`${BASE_ROUTING_PATH}/create-plan-v2`} />
      <Route
        exact
        path={`${BASE_ROUTING_PATH}/create-plan-v2`}
        render={(): JSX.Element => <CreatePlan employee={employee} />}
      />
      <Route exact path={`${BASE_ROUTING_PATH}/:planId`} render={(): JSX.Element => <Plan employee={employee} />} />
      <Redirect to="/404" />
    </Switch>
  )
}
